// extracted by mini-css-extract-plugin
export var offlineNotificaton = "fm_Lr";
export var offlineNotificaton__button = "fm_Lv";
export var offlineNotificaton__header = "fm_Lt";
export var offlineNotificaton__text = "fm_Lw";
export var offlineNotificaton__withCookie = "fm_Ls";